module.exports = __webpack_public_path__ + "static/media/lungs.5abe5880.svg";